import { CardSlider } from 'app/components/card-slider';
import { OnboardingProgress } from 'app/components/progress';
import { Column } from 'app/design/primitives/box';
import { usePresentPartageClubCarouselItems } from 'app/screens/intro/present-partage-club-carousel-items';
import { createTheme as createDSTheme } from 'app/shopify';
import { useState } from 'react';
import type { LayoutChangeEvent } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

const theme = createDSTheme();

export function IntroSideCardSlider() {
  const carouselItems = usePresentPartageClubCarouselItems();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [columnWidth, setColumnWidth] = useState(0);
  const onColumnLayout = (e: LayoutChangeEvent) => {
    const { width } = e.nativeEvent.layout;
    if (width > 0) {
      setColumnWidth(width);
    }
  };

  if (carouselItems.length === 0) {
    return null;
  }

  return (
    <Column flex={1} onLayout={onColumnLayout}>
      <CardSlider
        autoScrollDelay={6000}
        autoScrollToNext
        containerWidth={columnWidth > 0 ? columnWidth : undefined}
        items={carouselItems}
        showArrows
        onItemChange={(_, index) => setCurrentIndex(index)}
        renderFooter={() => (
          <SafeAreaView
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              paddingHorizontal: theme.spacing['spacing.general.x4'],
            }}
          >
            <Column gap="spacing.general.x2" paddingBottom="spacing.general.x4" width="100%">
              <OnboardingProgress currentStep={currentIndex} totalSteps={carouselItems.length} />
            </Column>
          </SafeAreaView>
        )}
      />
    </Column>
  );
}
